// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import { CSSProperties } from 'react';

const colors = {
  bgLight: '#f0faf3',
  border: '#00403E33',
  white: '#fff',
  white80: '#FFFFFF80',
  darkGreen: '#004140',
  darkGreen80: '#004140B2'
} as const;

// Header
export const headerStyle: CSSProperties = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '20px 30px',
  backgroundColor: colors.bgLight,
  borderBottom: `0.5px solid ${colors.border}`,
  width: '100%',
  boxSizing: 'border-box'
};

export const headerLogoWrapperStyle: CSSProperties = {
  display: 'flex',
  alignItems: 'center'
};

export const headerUserSectionStyle: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: '12px'
};

export const headerIconButtonStyle: CSSProperties = {
  width: 40,
  height: 40,
  backgroundColor: '#eef2ff',
  color: '#4338ca',
  fontWeight: 600
};

export const userInfoWrapperStyle: CSSProperties = {
  display: 'flex',
  flexDirection: 'column'
};

export const userNameStyle: CSSProperties = {
  fontSize: 14,
  fontWeight: 600,
  color: '#004140'
};

export const userEmailStyle: CSSProperties = {
  fontSize: 12,
  color: colors.darkGreen
};
